var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginHeader2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 83,
    viewBox: "0 0 149 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.155914 0.674496L5.35396 7.4592C8.05297 10.9513 12.5513 12.2484 16.7498 10.7518L17.9494 10.3527C22.9475 8.45695 28.5455 10.9513 30.6447 15.8403L30.8446 16.2394C32.8439 21.1284 38.2419 23.523 43.34 21.8268C48.738 20.0309 54.536 23.0241 56.1354 28.5117L58.9343 37.8906C60.5337 43.3782 66.3316 46.3715 71.8296 44.4758L84.0251 40.1854C89.1232 38.3895 94.7212 41.0834 96.6205 46.1719L98.8197 52.2582C100.919 57.8456 107.616 60.4398 113.014 57.4465L113.214 57.3467C119.112 54.1539 126.31 57.4465 127.809 64.0317C130.008 74.5081 137.406 82.091 148.102 82.091H148.301V0.574722H132.707C132.507 0.674497 0.155914 0.674496 0.155914 0.674496Z",
    fill: "#098D98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHeader2);
export default __webpack_public_path__ + "static/media/login-header2.138ccd98f9f415a35060b3762f276f40.svg";
export { ForwardRef as ReactComponent };